<template>
	<div v-if="sheetRow != null" class="sheet-row-info">
		<div class="sheet-row-info-title">
			{{ $t('winelist.addWineModal.sheetRowInfoTitle') }}
		</div>
		<div class="sheet-row-info-grid">
			<div v-if="hasValue(sheetRow.producer)" class="info-item">
				<span class="info-label">{{ $t('winelist.addWineModal.sheetRowProducer') }}</span>
				<span class="info-value">{{ sheetRow.producer }}</span>
			</div>
			<div v-if="hasValue(sheetRow.articleName)" class="info-item">
				<span class="info-label">{{ $t('winelist.addWineModal.sheetRowArticleName') }}</span>
				<span class="info-value">{{ sheetRow.articleName }}</span>
			</div>
			<div v-if="hasValue(sheetRow.year)" class="info-item">
				<span class="info-label">{{ $t('winelist.addWineModal.sheetRowYear') }}</span>
				<span class="info-value">{{ sheetRow.year }}</span>
			</div>
			<div v-if="hasValue(sheetRow.bottleSize)" class="info-item">
				<span class="info-label">{{ $t('winelist.addWineModal.sheetRowBottleSize') }}</span>
				<span class="info-value">{{ sheetRow.bottleSize }}</span>
			</div>
			<div v-if="hasValue(sheetRow.land)" class="info-item">
				<span class="info-label">{{ $t('winelist.addWineModal.sheetRowLand') }}</span>
				<span class="info-value">{{ sheetRow.land }}</span>
			</div>
			<div v-if="hasValue(sheetRow.region)" class="info-item">
				<span class="info-label">{{ $t('winelist.addWineModal.sheetRowRegion') }}</span>
				<span class="info-value">{{ sheetRow.region }}</span>
			</div>
			<div v-if="hasValue(sheetRow.wineType)" class="info-item">
				<span class="info-label">{{ $t('winelist.addWineModal.sheetRowWineType') }}</span>
				<span class="info-value">{{ sheetRow.wineType }}</span>
			</div>
			<div v-if="hasValue(sheetRow.grapeVariety)" class="info-item">
				<span class="info-label">{{ $t('winelist.addWineModal.sheetRowGrapeVariety') }}</span>
				<span class="info-value">{{ sheetRow.grapeVariety }}</span>
			</div>
			<div v-if="hasValue(sheetRow.supplier)" class="info-item">
				<span class="info-label">{{ $t('winelist.addWineModal.sheetRowSupplier') }}</span>
				<span class="info-value">{{ sheetRow.supplier }}</span>
			</div>
			<div v-if="hasValue(sheetRow.quantity) &&hasValue(sheetRow.unitPrice)" class="info-item">
				<span class="info-label">{{ $t('winelist.addWineModal.sheetRowAmount') }} | {{ $t('winelist.addWineModal.sheetRowPrice') }}</span>
				<span class="info-value">{{ sheetRow.quantity }} | {{ formattedPrice }}</span>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getVenueCurrency } from '@/utils/functions'

export default {
	name: 'SheetRowInfo',
	props: {
		sheetRow: {
			type: Object,
			default: null,
		},
	},
	computed: {
		...mapGetters(['getVenue']),
		/**
		 * The unit price formatted with the venue currency.
		 */
		formattedPrice() {
			const price = Number(this.sheetRow.unitPrice)
			if (isNaN(price)) {
				return this.sheetRow.unitPrice
			}
			const currency = getVenueCurrency(this.getVenue)
			return `${price.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${currency}`
		},
	},
	methods: {
		hasValue(value) {
			return value != null && value !== ''
		},
	},
}
</script>

<style scoped>
.sheet-row-info {
	background: var(--color-gray-300);
	border: 1px solid var(--color-gray-200);
	border-radius: 4px;
	padding: var(--margin-s) var(--margin-l);
  margin: 0 var(--margin-l) var(--margin-m);
}

.sheet-row-info-title {
	font-weight: 700;
	text-transform: uppercase;
	color: var(--color-primary-500);
	margin-bottom: var(--margin-s);
}

.sheet-row-info-grid {
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
	gap: var(--margin-xs) var(--margin-m);
}

.info-item {
	display: flex;
	flex-direction: column;
}

.info-label {
	font-size: 12px;
	color: var(--color-gray-150);
	text-transform: uppercase;
}

.info-value {
	color: var(--color-white);
	font-weight: 600;
}
</style>